import {
    ICubeSourceHierarchyPolicy,
    ICubeSourcePolicyHierarchyProperties,
    IDimensionPolicyOptions,
} from "../../PA.HyperRectangle.Core/CubeSource.IF";
import { DimensionType } from "../../PA.Core/PA.Core.IF.Hierarchy";
import * as _ from "lodash";
import { WB_PeriodRow, WB_ScenarioPlanRow } from "../../PA.Core/PAdbSchemaRows";
import { PAdbContext } from "../../PA.Core/PAdbContext";
import { esWB_Period, esWB_Published_Model, esWB_ScnPlan } from "../../PA.Core/PAdbSchema";
import { HierarchyUsage } from "../../PA.MD.Hierarchy/HierarchyUsage";

export class ScenarioPlanHierarchyPolicy implements ICubeSourceHierarchyPolicy {
    private dbContext: PAdbContext;
    constructor() {
        this.dbContext = new PAdbContext();
    }
    get PolicyId(): string {
        return "ScenarionPlan";
    }

    async getHierarchyProperties(
        dimType: DimensionType,
        options: IDimensionPolicyOptions,
    ): Promise<ICubeSourcePolicyHierarchyProperties> {
        if (_.isEmpty(options) || _.isEmpty(options?.CubeSource)) return undefined;

        //-- Get the Plan Type Row
        let scnPlanRow: WB_ScenarioPlanRow = undefined;
        if (!_.isEmpty(options.WB_ScenarioPlanRow)) scnPlanRow = options.WB_ScenarioPlanRow;
        else if (_.isNumber(options.WB_SCNPLAN_ID))
            scnPlanRow = await this.dbContext.find(esWB_ScnPlan, options.WB_SCNPLAN_ID);

        if (_.isEmpty(scnPlanRow)) return undefined;

        let pmRow = scnPlanRow.WB_PublishedModelRow;
        if (_.isEmpty(pmRow)) {
            pmRow = await this.dbContext.find(esWB_Published_Model, scnPlanRow.cif.WB_PublishedModel);
        }

        const hu = new HierarchyUsage();
        switch (dimType) {
            case DimensionType.Customer: {
                const leafLevel =
                    (await hu.getSrcEntityLevelId(
                        "Customer",
                        scnPlanRow.cif.WB_CUSTH_ID,
                        pmRow.cif.WB_ENTITY_ID_CUSTOMER,
                    )) || "";
                return {
                    HierarchyId: scnPlanRow.cif.WB_CUSTH_ID,
                    HierarchyCreateOptions: { bFullHierarchy: true },
                    LeafLevel: leafLevel,
                    EffectiveStartDt: scnPlanRow.StartDt,
                    EffectiveEndDt: scnPlanRow.EndDt,
                };
            }

            case DimensionType.Product: {
                const leafLevel =
                    (await hu.getSrcEntityLevelId(
                        "Product",
                        scnPlanRow.cif.WB_PRDH_ID,
                        pmRow.cif.WB_ENTITY_ID_PRODUCT,
                    )) || "";
                return {
                    HierarchyId: scnPlanRow.cif.WB_PRDH_ID,
                    LeafLevel: leafLevel,
                    EffectiveStartDt: scnPlanRow.StartDt,
                    EffectiveEndDt: scnPlanRow.EndDt,
                };
            }

            case DimensionType.Time: {
                const leafLevel =
                    (await hu.getSrcEntityLevelId(
                        "Period",
                        scnPlanRow.cif.WB_PERIODH_ID,
                        pmRow.cif.WB_ENTITY_ID_PERIOD,
                    )) || "";
                return {
                    HierarchyId: scnPlanRow.cif.WB_PERIODH_ID,
                    LeafLevel: leafLevel,
                    EffectiveStartDt: scnPlanRow.StartDt,
                    EffectiveEndDt: scnPlanRow.EndDt,
                };
            }

            default:
                return undefined;
        }
    }
}
